import { Alerts, Neutrals } from './colors';

export const FOCUS_COLOR = Alerts.Blue500;

// Default focus ring — bypasses the global `:focus-visible { outline: none }` CSS rule
// because box-shadow is not affected by that rule.
// Double ring: 2px white gap + 2px Blue500 outer ring.
export const DEFAULT_FOCUS_RING = { boxShadow: `0 0 0 2px ${Neutrals.main.White}, 0 0 0 4px ${FOCUS_COLOR}` } as any;

// Inset variant for edge-to-edge list rows (e.g. scrollable dropdowns), where an outward ring
// would be clipped by the scroll container or overdrawn by adjacent rows.
export const INSET_FOCUS_RING = { boxShadow: `inset 0 0 0 2px ${FOCUS_COLOR}` } as any;
